import './AutonomousMonitors.scss';
import { useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { PendingContent, SearchInputField, Space, Spinner } from 'plume-ui';

import { useGlobalDemo } from '../../../../components/GlobalDemo/GlobalDemo';
import { DemoId } from '../../../../components/GlobalDemo/steps';
import useAutonomousMonitors from '../../hooks/useAutonomousMonitors';
import AutonomousMonitorCell from '../AutonomousMonitorCell/AutonomousMonitorCell';
import SupportOutreachModal from '../SupportOutreach/SupportOutreachModal';

const AutonomousMonitors = () => {
  const { t } = useTranslation();
  const { setDemoId } = useGlobalDemo();

  const [supportOutreachModalId, setSupportOutreachModalId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const {
    isLoading: loadingMonitorList,
    data: monitorList,
    error: monitorListError,
  } = useAutonomousMonitors();

  useEffect(() => {
    // No demo if there are no monitors
    if (!monitorList?.length) return;
    setDemoId(DemoId.AutonomousMonitors);
    return () => setDemoId(DemoId.None);
  }, [monitorList]);

  const filteredData = useMemo(
    () =>
      (monitorList || []).filter((monitor) =>
        monitor.name.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    [monitorList, searchQuery],
  );

  return (
    <span className="AutonomousMonitors">
      <div className="AutonomousMonitors__header">
        <SearchInputField
          id={'monitorSearch'}
          rounded
          placeholder={t('monitors.searchMonitor.title')}
          onChange={(event) => {
            setSearchQuery((event.target as HTMLInputElement).value || '');
            window.dispatchEvent(new Event('resize'));
          }}
        />
      </div>

      <Space size="s" />
      <PendingContent loading={loadingMonitorList} loader={Spinner}>
        <div className="AutonomousMonitors__grid">
          {filteredData?.map((monitor) => (
            <div className="AutonomousMonitors__card" key={monitor.id}>
              <AutonomousMonitorCell
                monitor={monitor}
                onOpenSupportOutreach={(monitorId) =>
                  setSupportOutreachModalId(monitorId)
                }
              />
            </div>
          ))}
          {!loadingMonitorList &&
            (!Boolean(monitorList) || Boolean(monitorListError)) && (
              <div className="AutonomousMonitors__noData">
                {t('somethingWentWrong')}
              </div>
            )}
          {!loadingMonitorList && monitorList && !monitorList.length && (
            <div className="AutonomousMonitors__noData">
              {t('monitors.autonomous.noMonitorsAvailable')}
            </div>
          )}
          {!loadingMonitorList && searchQuery && !filteredData?.length && (
            <div className="AutonomousMonitors__noData">{t('noResults')}</div>
          )}
        </div>
        <Space size="l" />
      </PendingContent>
      <SupportOutreachModal
        monitorId={supportOutreachModalId}
        isOpen={Boolean(supportOutreachModalId)}
        onRequestClose={() => setSupportOutreachModalId('')}
      />
    </span>
  );
};

export default AutonomousMonitors;
